import styled from "styled-components";
import FontBase from "./FontBase";

const FontPBold = styled(FontBase)`
  font-weight:bold;
`;

export default FontPBold;
